import React, { useEffect, createElement } from 'react';
import { Shield, Check, ArrowRight, CheckCircle, XCircle } from 'lucide-react';
import { CountdownTimer } from './components/CountdownTimer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { TestimonialCard } from './components/TestimonialCard';
import { FAQ } from './components/FAQ';
import { ProductCarousel } from './components/ProductCarousel';
const CHECKOUT_URL = 'https://checkout.larutadelconocimiento.com/cart/43711786385517:1';
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/4ntpJ2BGqB48Q7NBeKeunf/MOCKUP_AYRFRYER_PACK.png';
const BONUS_1_IMAGE = 'https://cdn.magicpatterns.com/uploads/1FMDhs4DYFYW75C5BF9vET/BONO_1_AIRFRYER.png';
const BONUS_2_IMAGE = 'https://cdn.magicpatterns.com/uploads/qPCQLMaZZM1tggGQq9wXM4/BONO_2_AIRFRYER.png';
const BONUS_3_IMAGE = 'https://cdn.magicpatterns.com/uploads/nhU2L9Y6vY2nr6eRX6ojxS/BONO_3_AIRFRYER.png';
export function App() {
  // Meta Pixel Integration
  useEffect(() => {
    // @ts-ignore
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // @ts-ignore
    fbq('init', '1375239330854800');
    // @ts-ignore
    fbq('track', 'PageView');
  }, []);
  const scrollToCheckout = () => {
    const element = document.getElementById('compra');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="font-sans text-gray-900 bg-gray-50 min-h-screen pb-8" data-id="element-0">
      <SocialProofPopup data-id="element-1" />

      {/* 1. URGENCY HEADER BAR */}
      <div className="bg-red-600 text-white py-1 px-2 sticky top-0 z-40 shadow-md" data-id="element-2">
        <div className="max-w-6xl mx-auto flex items-center justify-center text-center" data-id="element-3">
          <div className="flex items-center space-x-2" data-id="element-4">
            <span className="font-bold uppercase text-xs md:text-sm tracking-wider" data-id="element-5">
              ⏳ OFERTA EXPIRA EN:
            </span>
            <CountdownTimer data-id="element-6" />
          </div>
        </div>
      </div>

      {/* 2. HERO SECTION */}
      <header className="bg-white pt-8 pb-10 px-4 border-b-8 border-yellow-500" data-id="element-7">
        <div className="max-w-4xl mx-auto text-center" data-id="element-8">
          <p className="text-gray-600 font-medium mb-4 text-sm md:text-base" data-id="element-9">
            🍗 Para personas con Airfryer que quieren resolver comidas sin
            pensar, sin ensuciar de más y sin caer en lo mismo
          </p>

          <h1 className="text-4xl md:text-6xl font-extrabold text-gray-900 leading-tight mb-6 uppercase" data-id="element-10">
            AIRFRYER PACK DEFINITIVO
          </h1>

          <div className="mb-6 transform hover:scale-[1.02] transition-transform duration-300" data-id="element-11">
            <img src={MAIN_IMAGE} alt="Airfryer Pack Definitivo Completo" className="mx-auto w-full max-w-lg drop-shadow-2xl cursor-pointer" onClick={scrollToCheckout} data-id="element-12" />
          </div>

          <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-13">
            El sistema simple para cocinar rico en minutos con tu Airfryer, sin
            improvisar tiempos, sin ensuciar de más y sin quedarte sin ideas.
          </h2>

          <button onClick={scrollToCheckout} className="inline-flex items-center justify-center w-full md:w-auto px-8 py-5 text-xl md:text-2xl font-bold text-white bg-green-600 rounded-lg shadow-xl hover:bg-green-700 hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-200 border-b-4 border-green-800" data-id="element-14">
            <span className="w-full text-center" data-id="element-15">👉 QUIERO ACCEDER AHORA</span>
          </button>

          <div className="mt-4 flex flex-col md:flex-row items-center justify-center text-sm text-gray-500 font-semibold gap-2 md:gap-4" data-id="element-16">
            <span className="flex items-center" data-id="element-17">
              <Shield className="w-4 h-4 mr-1 text-green-600" data-id="element-18" />✅ Garantía 7
              días
            </span>
            <span className="hidden md:inline" data-id="element-19">•</span>
            <span data-id="element-20">📩 Descarga inmediata</span>
            <span className="hidden md:inline" data-id="element-21">•</span>
            <span data-id="element-22">♾️ Acceso para siempre</span>
          </div>
        </div>
      </header>

      {/* 3. PAIN POINTS */}
      <section className="py-12 px-4 bg-gray-50" data-id="element-23">
        <div className="max-w-3xl mx-auto" data-id="element-24">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-8 text-gray-900" data-id="element-25">
            Si tenés Airfryer, dejame hacerte una pregunta honesta:
          </h2>

          <div className="bg-white p-8 rounded-xl shadow-md border-l-8 border-red-500" data-id="element-26">
            <p className="text-xl font-bold mb-6 text-gray-800" data-id="element-27">
              ¿Te pasa que tenés la Airfryer… pero igual terminás trabado con el
              "¿qué cocino hoy?"?
            </p>

            <p className="mb-6 text-gray-700" data-id="element-28">
              No porque cocines mal. No porque te falten recetas. Sino porque en
              el día a día aparecen problemas reales:
            </p>

            <ul className="space-y-4" data-id="element-29">
              {['Guardás recetas en redes y cuando las hacés no salen igual', 'Te quedás en las mismas 5 comidas "seguras"', 'Improvisás tiempos y temperaturas y te queda seco, crudo o sin crocancia', 'Por cansancio mental terminás en delivery', 'Ensuciás, te da pereza limpiar y volvés a lo mismo'].map((item, i) => <li key={i} className="flex items-start" data-id="element-30">
                  <div className="bg-red-100 p-1.5 rounded-full mr-3 mt-0.5 flex-shrink-0" data-id="element-31">
                    <XIcon className="w-4 h-4 text-red-600" data-id="element-32" />
                  </div>
                  <span className="text-gray-800 font-medium" data-id="element-33">{item}</span>
                </li>)}
            </ul>

            <p className="mt-6 text-gray-800 font-bold italic border-t pt-4 text-lg" data-id="element-34">
              Y lo peor: cuando llega la hora de comer… ya estás cansado antes
              de empezar.
            </p>
          </div>

          {/* STRATEGIC BUTTON 1 */}
          <div className="mt-10 text-center" data-id="element-35">
            <button onClick={scrollToCheckout} className="inline-flex items-center justify-center px-8 py-4 text-xl font-bold text-white bg-green-600 rounded-lg shadow-lg hover:bg-green-700 transition-all transform hover:-translate-y-1 border-b-4 border-green-800" data-id="element-36">
              👉 QUIERO RESOLVER MIS COMIDAS
            </button>
          </div>
        </div>
      </section>

      {/* 4. PROBLEM SECTION - Black Background */}
      <section className="py-12 px-4 bg-gray-900 text-white" data-id="element-37">
        <div className="max-w-3xl mx-auto text-center" data-id="element-38">
          <h2 className="text-3xl font-bold mb-6 text-red-500 uppercase tracking-wide" data-id="element-39">
            El problema que nadie dice en voz alta
          </h2>
          <p className="text-xl mb-8 leading-relaxed text-gray-300 font-bold" data-id="element-40">
            La Airfryer no falla. Falla el sistema.
          </p>

          <p className="text-lg mb-6 text-gray-400" data-id="element-41">La mayoría cocina con:</p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left mb-8" data-id="element-42">
            {['Recetas sueltas sin orden', 'Sin base real de tiempos y temperaturas', 'Sin entender cómo ajustar según su modelo', 'Sin método para adaptar recetas tradicionales', 'Sin un recetario organizado por momentos del día'].map((item, i) => <div key={i} className="flex items-center bg-gray-800 p-4 rounded-lg border border-gray-700 shadow-sm" data-id="element-43">
                <div className="w-3 h-3 bg-red-500 rounded-full mr-3 flex-shrink-0" data-id="element-44"></div>
                <span className="font-medium" data-id="element-45">{item}</span>
              </div>)}
          </div>

          <p className="mt-8 text-2xl font-light italic text-gray-300" data-id="element-46">
            Resultado:{' '}
            <span className="text-white font-bold bg-red-900/50 px-2 py-1 rounded" data-id="element-47">
              fricción, repetición… y más delivery.
            </span>
          </p>
        </div>
      </section>

      {/* 5. SOLUTION INTRO */}
      <section className="py-14 px-4 bg-gradient-to-b from-yellow-50 to-white" data-id="element-48">
        <div className="max-w-4xl mx-auto text-center" data-id="element-49">
          <div className="inline-block bg-green-100 text-green-800 font-bold px-4 py-1.5 rounded-full mb-6 text-sm tracking-widest uppercase" data-id="element-50">
            ✅ LA SOLUCIÓN
          </div>
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6" data-id="element-51">
            AIRFRYER PACK DEFINITIVO
          </h2>
          <p className="text-xl text-gray-700 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-52">
            Un pack organizado para que abras, elijas, cocines y listo.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-10" data-id="element-53">
            {['📂 Abrís el pack', '👆 Elegís según el momento del día', '⏱️ Usás tiempos/temperaturas base', '🍽️ Cocinás sin pensar', '🧽 Limpiás rápido'].map((item, i) => <div key={i} className="bg-white p-4 rounded-xl shadow border-b-4 border-yellow-500 flex items-center justify-center text-center h-full" data-id="element-54">
                <span className="font-bold text-gray-800 text-sm md:text-base" data-id="element-55">
                  {item}
                </span>
              </div>)}
          </div>

          <p className="text-2xl font-bold text-gray-900 mb-8" data-id="element-56">
            Sin vueltas. Sin improvisar. Sin quedarte sin ideas.
          </p>

          <button onClick={scrollToCheckout} className="inline-block px-8 py-4 text-xl font-bold text-white bg-green-600 rounded-full shadow-lg hover:bg-green-700 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 border-b-4 border-green-800" data-id="element-57">
            👉 QUIERO MI SISTEMA DE AIRFRYER
          </button>
        </div>
      </section>

      {/* 6. PRODUCT DETAILS - 4 TOMOS */}
      <section className="py-12 px-4 bg-white" data-id="element-58">
        <div className="max-w-5xl mx-auto" data-id="element-59">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-900" data-id="element-60">
            📘 ¿Qué incluye exactamente el AIRFRYER PACK DEFINITIVO?
          </h2>

          <p className="text-center text-xl text-gray-600 mb-10" data-id="element-61">
            Un sistema completo dividido en 4 tomos + 3 bonos.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-62">
            {/* TOMO 1 */}
            <div className="bg-gray-50 p-8 rounded-xl border border-gray-200 hover:border-yellow-400 transition-colors shadow-sm" data-id="element-63">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-start" data-id="element-64">
                <span className="text-2xl mr-3" data-id="element-65">📗</span>
                TOMO 1 — Base + Método (el que te evita errores)
              </h3>
              <p className="text-gray-600 mb-4 font-bold" data-id="element-66">
                Tu Airfryer: tipo, cuidado, errores, tabla base y adaptación
              </p>
              <p className="text-gray-600 mb-2 text-sm uppercase tracking-wide font-bold" data-id="element-67">
                Incluye:
              </p>
              <ul className="space-y-2 text-gray-600 mb-6" data-id="element-68">
                <li className="flex items-start" data-id="element-69">
                  <Check className="w-4 h-4 text-green-500 mr-2 mt-1" data-id="element-70" /> Qué
                  tipo de Airfryer tenés y cómo cuidarla
                </li>
                <li className="flex items-start" data-id="element-71">
                  <Check className="w-4 h-4 text-green-500 mr-2 mt-1" data-id="element-72" /> Errores
                  más comunes y cómo evitarlos
                </li>
                <li className="flex items-start" data-id="element-73">
                  <Check className="w-4 h-4 text-green-500 mr-2 mt-1" data-id="element-74" /> Tabla
                  básica de tiempos y temperaturas
                </li>
                <li className="flex items-start" data-id="element-75">
                  <Check className="w-4 h-4 text-green-500 mr-2 mt-1" data-id="element-76" /> Cómo
                  adaptar cualquier receta tradicional a Airfryer
                </li>
              </ul>
              <p className="text-gray-800 font-bold italic border-t pt-4" data-id="element-77">
                👉 Abrís este tomo una vez… y dejás de "cocinar a ojo" para
                siempre.
              </p>
            </div>

            {/* TOMO 2 */}
            <div className="bg-gray-50 p-8 rounded-xl border border-gray-200 hover:border-yellow-400 transition-colors shadow-sm" data-id="element-78">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-start" data-id="element-79">
                <span className="text-2xl mr-3" data-id="element-80">📙</span>
                TOMO 2 — Desayunos/Brunch + Snacks/Entradas/Aperitivos
              </h3>
              <p className="text-gray-600 mb-2 text-sm uppercase tracking-wide font-bold" data-id="element-81">
                Incluye:
              </p>
              <ul className="space-y-2 text-gray-600 mb-6" data-id="element-82">
                <li className="flex items-start" data-id="element-83">
                  <Check className="w-4 h-4 text-green-500 mr-2 mt-1" data-id="element-84" /> Recetas
                  de Desayunos y Brunch
                </li>
                <li className="flex items-start" data-id="element-85">
                  <Check className="w-4 h-4 text-green-500 mr-2 mt-1" data-id="element-86" /> Recetas
                  de Snacks, entradas y aperitivos
                </li>
              </ul>
              <p className="text-gray-800 font-bold italic border-t pt-4" data-id="element-87">
                👉 Ideal para cuando querés algo rápido y rico sin pensar
                demasiado.
              </p>
            </div>

            {/* TOMO 3 */}
            <div className="bg-gray-50 p-8 rounded-xl border border-gray-200 hover:border-yellow-400 transition-colors shadow-sm" data-id="element-88">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-start" data-id="element-89">
                <span className="text-2xl mr-3" data-id="element-90">📘</span>
                TOMO 3 — Almuerzos rápidos + Cenas ligeras y saludables
              </h3>
              <p className="text-gray-600 mb-2 text-sm uppercase tracking-wide font-bold" data-id="element-91">
                Incluye:
              </p>
              <ul className="space-y-2 text-gray-600 mb-6" data-id="element-92">
                <li className="flex items-start" data-id="element-93">
                  <Check className="w-4 h-4 text-green-500 mr-2 mt-1" data-id="element-94" /> Recetas
                  de Almuerzos rápidos y completos
                </li>
                <li className="flex items-start" data-id="element-95">
                  <Check className="w-4 h-4 text-green-500 mr-2 mt-1" data-id="element-96" /> Recetas
                  de Cenas ligeras y saludables
                </li>
              </ul>
              <p className="text-gray-800 font-bold italic border-t pt-4" data-id="element-97">
                👉 Para resolver el 80% de tu semana sin caer en delivery.
              </p>
            </div>

            {/* TOMO 4 */}
            <div className="bg-gray-50 p-8 rounded-xl border border-gray-200 hover:border-yellow-400 transition-colors shadow-sm" data-id="element-98">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-start" data-id="element-99">
                <span className="text-2xl mr-3" data-id="element-100">📕</span>
                TOMO 4 — Postres/Panes/Dulces + Guarniciones/Salsas
              </h3>
              <p className="text-gray-600 mb-2 text-sm uppercase tracking-wide font-bold" data-id="element-101">
                Incluye:
              </p>
              <ul className="space-y-2 text-gray-600 mb-6" data-id="element-102">
                <li className="flex items-start" data-id="element-103">
                  <Check className="w-4 h-4 text-green-500 mr-2 mt-1" data-id="element-104" /> Recetas
                  de Postres, panes y dulces
                </li>
                <li className="flex items-start" data-id="element-105">
                  <Check className="w-4 h-4 text-green-500 mr-2 mt-1" data-id="element-106" /> Recetas
                  de Guarniciones y salsas que combinan con todo
                </li>
              </ul>
              <p className="text-gray-800 font-bold italic border-t pt-4" data-id="element-107">
                👉 Para sumar variedad real y "comer bien" sin complicarte.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 6.5 PRODUCT PREVIEW CAROUSEL */}
      <section className="py-14 px-4 bg-gray-100" data-id="element-108">
        <div className="max-w-4xl mx-auto text-center" data-id="element-109">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3" data-id="element-110">
            👀 Mirá cómo es por dentro
          </h2>
          <p className="text-gray-600 text-lg mb-10 max-w-xl mx-auto" data-id="element-111">
            Páginas reales del pack. Recetas claras, menús organizados y tips
            prácticos.
          </p>
          <ProductCarousel onImageClick={scrollToCheckout} data-id="element-112" />
        </div>
      </section>

      {/* 7. BEFORE / AFTER */}
      <section className="py-12 px-4 bg-gray-100" data-id="element-113">
        <div className="max-w-4xl mx-auto" data-id="element-114">
          <h2 className="text-3xl font-bold text-center mb-8 text-gray-900" data-id="element-115">
            🔄 Antes vs Después
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-0 md:gap-8" data-id="element-116">
            {/* Before */}
            <div className="bg-white p-8 rounded-t-xl md:rounded-xl shadow-sm border-t-8 border-red-500 mb-2 md:mb-0" data-id="element-117">
              <h3 className="text-xl font-bold text-red-600 mb-6 flex items-center" data-id="element-118">
                <XIcon className="w-6 h-6 mr-2" data-id="element-119" />
                Antes del Pack
              </h3>
              <ul className="space-y-3" data-id="element-120">
                {['“¿Qué cocino hoy?” todos los días', 'Recetas guardadas que no usás', 'Tiempos a ojo y resultados irregulares', 'Delivery por cansancio mental', 'Más desorden al limpiar'].map((item, i) => <li key={i} className="flex items-start text-gray-600" data-id="element-121">
                    <span className="text-red-400 mr-3 font-bold" data-id="element-122">•</span>
                    {item}
                  </li>)}
              </ul>
            </div>

            {/* After */}
            <div className="bg-white p-8 rounded-b-xl md:rounded-xl shadow-xl border-t-8 border-green-500 transform md:scale-105 z-10" data-id="element-123">
              <h3 className="text-xl font-bold text-green-600 mb-6 flex items-center" data-id="element-124">
                <Check className="w-6 h-6 mr-2" data-id="element-125" />
                Después del Pack
              </h3>
              <ul className="space-y-3" data-id="element-126">
                {['Recetario organizado por momentos del día', 'Recetas prácticas para rotar sin repetir', 'Tabla base + método de adaptación', 'Menos delivery y más constancia', 'Menos fricción, más rapidez'].map((item, i) => <li key={i} className="flex items-start font-bold text-gray-800" data-id="element-127">
                    <Check className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" data-id="element-128" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          {/* STRATEGIC BUTTON 2 */}
          <div className="mt-12 text-center" data-id="element-129">
            <button onClick={scrollToCheckout} className="inline-flex items-center justify-center px-8 py-4 text-xl font-bold text-white bg-green-600 rounded-lg shadow-lg hover:bg-green-700 transition-all transform hover:-translate-y-1 border-b-4 border-green-800" data-id="element-130">
              👉 QUIERO ESTE CAMBIO EN MI COCINA
            </button>
          </div>
        </div>
      </section>

      {/* 8. BONUSES - Black Background for Contrast */}
      <section className="py-14 px-4 bg-gray-900 text-white" data-id="element-131">
        <div className="max-w-6xl mx-auto" data-id="element-132">
          <div className="text-center mb-12" data-id="element-133">
            <span className="bg-yellow-500 text-black font-bold px-4 py-1 rounded-full uppercase tracking-wider text-sm" data-id="element-134">
              🎁 Regalos especiales
            </span>
            <h2 className="text-3xl md:text-5xl font-bold mt-6 mb-3 text-white" data-id="element-135">
              BONOS INCLUIDOS HOY
            </h2>
            <p className="text-xl text-gray-400" data-id="element-136">(sin costo adicional)</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-137">
            {/* Bonus 1 */}
            <div className="bg-white text-gray-900 rounded-xl overflow-hidden shadow-2xl transform hover:-translate-y-2 transition-transform duration-300 border-2 border-yellow-500/50" data-id="element-138">
              <div className="relative aspect-square bg-gray-100 cursor-pointer" onClick={scrollToCheckout} data-id="element-139">
                <img src={BONUS_1_IMAGE} alt="Bono 1 Menús" className="w-full h-full object-cover" data-id="element-140" />
                <div className="absolute top-4 right-4 bg-red-600 text-white font-bold px-3 py-1 rounded shadow-lg transform rotate-3 text-sm" data-id="element-141">
                  GRATIS HOY
                </div>
              </div>
              <div className="p-6" data-id="element-142">
                <p className="text-green-600 font-bold mb-3 text-lg" data-id="element-143">
                  HOY: GRATIS
                </p>
                <h3 className="text-xl font-bold mb-2 leading-tight" data-id="element-144">
                  🎁 Bono #1 – 30 menús semanales + lista de compras
                </h3>
                <p className="text-gray-600 text-sm mt-2" data-id="element-145">
                  Para que no tengas que pensar qué cocinar y tengas el plan +
                  la compra resuelta.
                </p>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="bg-white text-gray-900 rounded-xl overflow-hidden shadow-2xl transform hover:-translate-y-2 transition-transform duration-300 border-2 border-yellow-500/50" data-id="element-146">
              <div className="relative aspect-square bg-gray-100 cursor-pointer" onClick={scrollToCheckout} data-id="element-147">
                <img src={BONUS_2_IMAGE} alt="Bono 2 Limpieza" className="w-full h-full object-cover" data-id="element-148" />
                <div className="absolute top-4 right-4 bg-red-600 text-white font-bold px-3 py-1 rounded shadow-lg transform rotate-3 text-sm" data-id="element-149">
                  GRATIS HOY
                </div>
              </div>
              <div className="p-6" data-id="element-150">
                <p className="text-green-600 font-bold mb-3 text-lg" data-id="element-151">
                  HOY: GRATIS
                </p>
                <h3 className="text-xl font-bold mb-2 leading-tight" data-id="element-152">
                  🎁 Bono #2 – Limpieza y cuidado (Airfryer como nueva)
                </h3>
                <p className="text-gray-600 text-sm mt-2" data-id="element-153">
                  Para mantenerla impecable, sin olores y sin arruinar el
                  antiadherente.
                </p>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="bg-white text-gray-900 rounded-xl overflow-hidden shadow-2xl transform hover:-translate-y-2 transition-transform duration-300 border-2 border-yellow-500/50" data-id="element-154">
              <div className="relative aspect-square bg-gray-100 cursor-pointer" onClick={scrollToCheckout} data-id="element-155">
                <img src={BONUS_3_IMAGE} alt="Bono 3 Festividades" className="w-full h-full object-cover" data-id="element-156" />
                <div className="absolute top-4 right-4 bg-red-600 text-white font-bold px-3 py-1 rounded shadow-lg transform rotate-3 text-sm" data-id="element-157">
                  GRATIS HOY
                </div>
              </div>
              <div className="p-6" data-id="element-158">
                <p className="text-green-600 font-bold mb-3 text-lg" data-id="element-159">
                  HOY: GRATIS
                </p>
                <h3 className="text-xl font-bold mb-2 leading-tight" data-id="element-160">
                  🎁 Bono #3 – Menú para festividades (Navidad • Año Nuevo •
                  Cumpleaños)
                </h3>
                <p className="text-gray-600 text-sm mt-2" data-id="element-161">
                  Ideas listas para lucirte sin complicarte cuando hay eventos.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 9. TESTIMONIALS */}
      <section className="py-12 px-4 bg-gray-50" data-id="element-162">
        <div className="max-w-6xl mx-auto" data-id="element-163">
          <h2 className="text-3xl font-bold text-center mb-10 text-gray-900" data-id="element-164">
            🧾 Lo que dicen otros
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-165">
            <TestimonialCard name="Valentina Ruiz" role="Ama de casa" location="Buenos Aires" content="Antes usaba la Airfryer solo para papas fritas. Con el pack ahora resuelvo almuerzos y cenas en minutos. Las recetas son súper fáciles y ricas." imageInitials="VR" data-id="element-166" />
            <TestimonialCard name="Gonzalo Torres" role="Padre soltero" location="Córdoba" content="Los menús semanales me salvaron la vida. Ya no tengo que pensar qué cocinar y la lista de compras me organiza todo. Recomendadísimo." imageInitials="GT" data-id="element-167" />
            <TestimonialCard name="Luciana Méndez" role="Profesional ocupada" location="Rosario" content="La guía de tiempos y temperaturas es clave. Antes me quedaba todo seco, ahora le agarré la mano y sale todo crocante y jugoso." imageInitials="LM" data-id="element-168" />
            <div className="md:col-span-3 grid grid-cols-1 md:grid-cols-2 gap-6 md:w-2/3 mx-auto" data-id="element-169">
              <TestimonialCard name="Facundo Herrera" role="Estudiante universitario" location="Mendoza" content="Ideal para los que tenemos poco tiempo y presupuesto. Las recetas son simples y no ensuciás nada. Me cambió la forma de comer." imageInitials="FH" data-id="element-170" />
              <TestimonialCard name="Carolina Paz" role="Mamá de 3" location="La Plata" content="Lo mejor es la variedad. Mis hijos comen de todo ahora y yo no me estreso. Y limpiar es mucho más fácil siguiendo los tips." imageInitials="CP" data-id="element-171" />
            </div>
          </div>
        </div>
      </section>

      {/* 10. PRICING / OFFER */}
      <section id="compra" className="py-14 px-4 bg-white" data-id="element-172">
        <div className="max-w-4xl mx-auto" data-id="element-173">
          <div className="border-4 border-dashed border-amber-500 rounded-3xl p-6 md:p-10 bg-amber-50 relative overflow-visible shadow-2xl" data-id="element-174">
            {/* Fixed ribbon */}
            <div className="absolute -top-5 -right-5 bg-amber-600 text-white px-6 py-2 font-bold rounded shadow-lg text-sm md:text-base z-10 transform rotate-3" data-id="element-175">
              🔥 OFERTA LIMITADA
            </div>

            <div className="text-center mb-8 pt-4" data-id="element-176">
              <p className="text-amber-700 font-bold text-lg md:text-xl uppercase tracking-widest mb-2" data-id="element-177">
                ⏰ Oferta por tiempo limitado
              </p>
              <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 leading-tight" data-id="element-178">
                AIRFRYER PACK DEFINITIVO
                <span className="block text-lg md:text-2xl font-medium text-gray-600 mt-2" data-id="element-179">
                  + los 3 bonos incluidos
                </span>
              </h2>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-inner mb-8 border border-gray-200" data-id="element-180">
              <h3 className="font-bold text-xl mb-6 border-b pb-4 text-gray-800" data-id="element-181">
                📦 Lo que recibís hoy:
              </h3>
              <ul className="space-y-4 mb-8" data-id="element-182">
                <li className="flex items-center font-bold text-gray-800 text-lg" data-id="element-183">
                  <Check className="w-6 h-6 text-green-600 mr-3 flex-shrink-0" data-id="element-184" />
                  <span data-id="element-185">TOMO 1 — Base + método</span>
                </li>
                <li className="flex items-center font-bold text-gray-800 text-lg" data-id="element-186">
                  <Check className="w-6 h-6 text-green-600 mr-3 flex-shrink-0" data-id="element-187" />
                  <span data-id="element-188">TOMO 2 — Desayunos/Brunch + Snacks</span>
                </li>
                <li className="flex items-center font-bold text-gray-800 text-lg" data-id="element-189">
                  <Check className="w-6 h-6 text-green-600 mr-3 flex-shrink-0" data-id="element-190" />
                  <span data-id="element-191">TOMO 3 — Almuerzos + Cenas</span>
                </li>
                <li className="flex items-center font-bold text-gray-800 text-lg" data-id="element-192">
                  <Check className="w-6 h-6 text-green-600 mr-3 flex-shrink-0" data-id="element-193" />
                  <span data-id="element-194">TOMO 4 — Postres + Guarniciones/Salsas</span>
                </li>
                <li className="flex items-center font-bold text-gray-800 text-lg" data-id="element-195">
                  <Check className="w-6 h-6 text-green-600 mr-3 flex-shrink-0" data-id="element-196" />
                  <span data-id="element-197">BONO #1 — Menús semanales + lista de compras</span>
                </li>
                <li className="flex items-center font-bold text-gray-800 text-lg" data-id="element-198">
                  <Check className="w-6 h-6 text-green-600 mr-3 flex-shrink-0" data-id="element-199" />
                  <span data-id="element-200">BONO #2 — Limpieza y cuidado</span>
                </li>
                <li className="flex items-center font-bold text-gray-800 text-lg" data-id="element-201">
                  <Check className="w-6 h-6 text-green-600 mr-3 flex-shrink-0" data-id="element-202" />
                  <span data-id="element-203">BONO #3 — Menú para festividades</span>
                </li>
                <li className="flex items-center font-bold text-gray-800 text-lg" data-id="element-204">
                  <Check className="w-6 h-6 text-green-600 mr-3 flex-shrink-0" data-id="element-205" />
                  <span data-id="element-206">
                    ⚡ Acceso inmediato 📥 Descarga digital ♾️ Acceso para
                    siempre
                  </span>
                </li>
              </ul>
            </div>

            <div className="text-center" data-id="element-207">
              <div className="flex flex-col items-center justify-center mb-6" data-id="element-208">
                <span className="text-gray-500 text-xl line-through mb-2" data-id="element-209">
                  Precio regular: ARS $62.960
                </span>
                <div className="flex flex-col md:flex-row items-center justify-center gap-3" data-id="element-210">
                  <span className="text-red-600 font-bold text-2xl animate-pulse whitespace-nowrap" data-id="element-211">
                    🔥 HOY SOLO:
                  </span>
                  <span className="text-5xl md:text-6xl font-extrabold text-green-600 whitespace-nowrap" data-id="element-212">
                    ARS $19.990
                  </span>
                </div>
              </div>

              <a href={CHECKOUT_URL} className="block w-full py-6 text-2xl md:text-3xl font-extrabold text-white bg-green-600 rounded-xl shadow-xl hover:bg-green-700 transform hover:-translate-y-1 transition-all duration-200 border-b-8 border-green-800 text-center" data-id="element-213">
                👉 OBTENER MI AIRFRYER PACK AHORA
              </a>

              <div className="mt-4 text-sm text-gray-500 flex items-center justify-center" data-id="element-214">
                Pago seguro. Entrega inmediata por email.
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 11. WHO IS THIS FOR */}
      <section className="py-12 px-4 bg-gray-50" data-id="element-215">
        <div className="max-w-3xl mx-auto" data-id="element-216">
          <div className="bg-white p-8 rounded-xl shadow-sm border-t-4 border-green-500" data-id="element-217">
            <h3 className="text-2xl font-bold mb-6 text-gray-900 text-center" data-id="element-218">
              👤 Para personas con Airfryer que:
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-219">
              {['tienen poco tiempo', 'quieren resolver comidas sin pensar', 'quieren resultados consistentes sin improvisar', 'quieren variedad real sin complicarse'].map((item, i) => <div key={i} className="flex items-center" data-id="element-220">
                  <CheckCircle className="w-6 h-6 text-green-500 mr-3 flex-shrink-0" data-id="element-221" />
                  <span className="text-gray-800 font-bold text-lg" data-id="element-222">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* 12. GUARANTEE */}
      <section className="py-12 px-4 bg-white" data-id="element-223">
        <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-8" data-id="element-224">
          <div className="flex-shrink-0 relative" data-id="element-225">
            {/* Shield badge */}
            <div className="w-32 h-36 relative" data-id="element-226">
              <svg viewBox="0 0 100 120" className="w-full h-full" data-id="element-227">
                <path d="M50 5 L95 20 L95 60 C95 85 75 105 50 115 C25 105 5 85 5 60 L5 20 Z" fill="#facc15" stroke="#ca8a04" strokeWidth="3" data-id="element-228" />
                <path d="M50 15 L85 27 L85 58 C85 78 68 95 50 103 C32 95 15 78 15 58 L15 27 Z" fill="#fef08a" data-id="element-229" />
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center" data-id="element-230">
                <span className="text-3xl" data-id="element-231">🛡️</span>
                <span className="font-extrabold text-yellow-900 text-sm leading-tight text-center mt-1" data-id="element-232">
                  GARANTÍA
                </span>
                <span className="font-bold text-yellow-800 text-xs leading-tight text-center" data-id="element-233">
                  7 DÍAS
                </span>
              </div>
            </div>
          </div>
          <div data-id="element-234">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-235">
              🛡️ GARANTÍA 7 DÍAS
            </h3>
            <p className="text-gray-700 leading-relaxed text-lg" data-id="element-236">
              Probalo 7 días. Si no te simplifica las comidas y no te da
              resultados más consistentes, pedís la devolución y listo. Sin
              vueltas.
            </p>
          </div>
        </div>
      </section>

      {/* 13. FAQ */}
      <section className="py-12 px-4 bg-gray-50" data-id="element-237">
        <div className="max-w-3xl mx-auto" data-id="element-238">
          <h2 className="text-3xl font-bold text-center mb-8 text-gray-900" data-id="element-239">
            ❓ Preguntas frecuentes
          </h2>
          <FAQ data-id="element-240" />
        </div>
      </section>

      {/* 14. FINAL CTA */}
      <section className="py-16 px-4 bg-gray-900 text-white text-center" data-id="element-241">
        <div className="max-w-3xl mx-auto" data-id="element-242">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-243">
            La Airfryer no debería sentirse como otra cosa que te consume
            energía.
          </h2>
          <p className="text-xl text-gray-300 mb-8 font-light" data-id="element-244">
            No necesitás más recetas sueltas. Necesitás un sistema listo para
            usar.
          </p>
          <button onClick={scrollToCheckout} className="inline-block px-10 py-5 text-xl md:text-2xl font-bold text-white bg-green-600 rounded-lg shadow-lg hover:bg-green-700 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-200 border-b-4 border-green-800" data-id="element-245">
            <span className="text-center" data-id="element-246">👉 QUIERO ACCEDER AHORA</span>
          </button>
          <p className="mt-6 text-gray-400 font-bold" data-id="element-247">
            📩 Descarga inmediata | ♾️ Acceso para siempre | ✅ Garantía 7 días
          </p>
        </div>
      </section>

      <footer className="py-8 bg-black text-gray-600 text-center text-sm" data-id="element-248">
        <p data-id="element-249">© 2026 Airfryer Pack Definitivo. Todos los derechos reservados.</p>
        <p className="mt-2" data-id="element-250">
          Este sitio no forma parte del sitio web de Facebook o Facebook Inc.
        </p>
      </footer>
    </div>;
}
function XIcon({
  className
}: {
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-251">
      <path d="M18 6 6 18" data-id="element-252" />
      <path d="m6 6 12 12" data-id="element-253" />
    </svg>;
}